(() => {
  const linkMap = new Map([
    ['https://suscripcion-pat.virtualpos.cl/grit-studio/e24f788d032de9c9f84d685eeaae6277', 'https://suscripcion-pat.virtualpos.cl/grit-studio/e667f0ceae590c9e4605974e09fb2280'],
    ['https://suscripcion-pat.virtualpos.cl/grit-studio/2676d588798c20dd3e972e6d60d8d8b5', 'https://suscripcion-pat.virtualpos.cl/grit-studio/23fec458a6ac980bd8cc18087d784af8'],
    ['https://suscripcion-pat.virtualpos.cl/grit-studio/139344958d230b39d7dec42f9ac6ebef', 'https://suscripcion-pat.virtualpos.cl/grit-studio/17ebadf16aba155f0fbf6d3dcefb3b93'],
    ['https://suscripcion-pat.virtualpos.cl/grit-studio/dd097974dd37993c472c0f6d3a4b719b', 'https://suscripcion-pat.virtualpos.cl/grit-studio/167e77d4f78f0cca440b8916f489223d'],
    ['https://suscripcion-pat.virtualpos.cl/grit-studio/7dbd2d70c6189c1ca62b27f7831e869c', 'https://suscripcion-pat.virtualpos.cl/grit-studio/5eac1802c5cb9068abd4784467bfcac5']
  ]);

  const updateLinks = (root = document) => {
    root.querySelectorAll('a[href*="suscripcion-pat.virtualpos.cl/grit-studio/"]').forEach((link) => {
      const cleanHref = link.href.split('?')[0].replace(/\/$/, '');
      const replacement = linkMap.get(cleanHref);
      if (replacement) link.href = replacement;
    });
  };

  const boot = () => {
    updateLinks();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) updateLinks(node);
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
